export default {
  entities: [],
};
